import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import { compose } from 'redux';
import AuthRoute from 'containers/AuthRoute';
import { EUserType } from 'services/BackendApi';
import { BankTransactionsPage } from './BankTransactionsPage';
import { BankTransactionsImportPage } from './BankTransactionsImportPage';
import { ReceiptPage } from './ReceiptPage';
import { PaymentPage } from './PaymentPage';

export interface BankTransactionsRoutingProps extends RouteComponentProps {}

export const BankTransactionsRoutingComponent = (props: BankTransactionsRoutingProps) => {
  return (
    <Switch>
      <AuthRoute
        allow={[EUserType.ADMIN, EUserType.FINANCE]}
        path={`${props.match.path}/import`}
        component={BankTransactionsImportPage}
        exact
      />
      <AuthRoute
        allow={[EUserType.ADMIN, EUserType.FINANCE, EUserType.SR]}
        path={`${props.match.path}/receipt/:uuid`}
        component={ReceiptPage}
        exact
      />
      <AuthRoute
        allow={[EUserType.ADMIN, EUserType.FINANCE, EUserType.SR]}
        path={`${props.match.path}/payment/:uuid`}
        component={PaymentPage}
        exact
      />
      <Route path={`${props.match.path}`} component={BankTransactionsPage} exact />
    </Switch>
  );
};

export const BankTransactionsRouting = compose(withRouter)(BankTransactionsRoutingComponent);
